import {
  CategoryScale,
  Chart as ChartJS,
  ChartData,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { observer } from "mobx-react";
import React from "react";
import { Line } from "react-chartjs-2";
import styled from "styled-components";

import Style from "@client/utils/Style";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
);

const Wrapper = styled.div`
  background: ${Style.palette.grayscale[0]};
  border-radius: ${Style.borderRadius};
  padding: 8px;
`;
const Title = styled.div`
  font-size: 24px;
  font-weight: ${Style.fontWeights.light};
  margin-bottom: 12px;
  text-align: center;
`;
const ChartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  title: React.ReactNode;
  data: ChartData<"line", number[], string>;
  emptyComponent: React.ReactNode;
  style?: React.CSSProperties;
};

@observer
class DashboardLineChart extends React.Component<Props> {
  render() {
    return (
      <Wrapper style={this.props.style}>
        <Title>{this.props.title}</Title>
        <ChartWrapper>
          {this.props.data.datasets[0].data.length > 0 ? (
            <Line
              style={{ maxHeight: "400px" }}
              options={{
                plugins: {
                  legend: {
                    position: "bottom",
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    afterBuildTicks: axis => {
                      axis.ticks = axis.ticks.filter(t =>
                        Number.isInteger(t.value),
                      );
                    },
                  },
                },
              }}
              data={this.props.data}
            />
          ) : (
            this.props.emptyComponent
          )}
        </ChartWrapper>
      </Wrapper>
    );
  }
}

export default DashboardLineChart;
